<template>
  <div class="field">
    <div class="field-label">
      <label class="has-text-black-bis is-italic is-size-3" v-if="label"
        :class="labelPosition === 'is-left' ? 'line-height' : 'label'">
        {{ label }}
      </label>
    </div>
    <div class="field-body">
      <div class="is-flex has-text-black-bis" v-if="isBomCreated  && !isCutOrder && hasMaterials">
        <span class="icon-checkmark mr-2"></span>
        <span class="line-height">All Available BOMs Created</span>
      </div>
      <div v-else>
        <o-checkbox class="p-0"
          v-model="create"
          v-if="!isCutOrder && shouldCreateBom"
          :disabled="submit">
          <span class="has-text-black-bis">
            Create BOMs for Assembly Items
          </span>
        </o-checkbox>
      </div>
      <div class="is-flex has-text-black-bis" v-if="isBomSubmitted && !isCutOrder && hasMaterials">
        <span class="icon-checkmark mr-2"></span>
        <span class="line-height">All Available BOMs Submitted</span>
      </div>
      <o-checkbox class="p-0"
        v-model="submit"
        :disabled="(shouldCreateBom && !create && !isBomCreated)"
        v-tooltip="{ content: isSubmitDisabled ? 'Not all Items are Purchased' : '' }"
        v-if="!isCutOrder && (bomsToSubmit?.length)"
      >
        <span class="has-text-black-bis">
          Submit Assembly Item BOMs
        </span>
      </o-checkbox>
      <div v-if="['manager-edit-detailing','cut-edit-detailing'].includes($store.state.activeScreen)">
        <o-checkbox class="p-0 reserve-checkbox" v-if="(isCutOrder && !hasNestedInvLoc) || (!isCutOrder && !hasNestedInvLoc && hasMaterials)"
          v-model="reserveMaterials">
          <span class="has-text-black-bis">
            Reserve Available Materials (Materials not reserved now can be reserved in Manufacturing)
          </span>
        </o-checkbox>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, onBeforeMount, ref } from 'vue';
import { useStore } from 'vuex';
import _ from 'lodash';
import Helper from '@/models/Helper';

export default ({
  props: {
    value: Object,
    label: String,
    isBomCreated: Boolean,
    isBomSubmitted: Boolean,
    isSubmitDisabled: Boolean,
    isCutOrder: Boolean,
    rowData: Object,
  },
  setup(props, { emit }) {
    const store = useStore();
    const shouldCreateBom = ref(null);
    const bomsToSubmit = ref(null);
    const hasMaterials = ref(null);
    const submit = computed({
      get: () => props.value.submit,
      set: (val) => {
        emit('update:value', { val, type: 'submit' });
      },
    });
    const create = computed({
      get: () => props.value.create,
      set: (val) => {
        emit('update:value', { val, type: 'create' });
      },
    });
    const reserveMaterials = computed({
      get: () => props.value.reserveMaterials,
      set: (val) => {
        emit('update:value', { val, type: 'reserveMaterials' });
      },
    });

    onBeforeMount(async () => {
      const assemblyItems = _.filter(props.rowData.items, { fromMasterCatalog: true })
      hasMaterials.value = !_.isEmpty(props.rowData.materials) || assemblyItems.length;
      shouldCreateBom.value = (await Helper.hasBomCreated(assemblyItems));
      if (!shouldCreateBom.value) {
        const hasToSubmit = _.find(props.rowData.materials, {stage: "preparation"})
        if (!_.isEmpty(hasToSubmit)) shouldCreateBom.value = true;
      }
      const boms = await props.rowData.getSubmitMaterials();
      bomsToSubmit.value = boms.filter((bom) => bom.stage === 'preparation');
      reserveMaterials.value = store.state.autoReserve;
    })

    const hasNestedInvLoc = computed(() => {
      let cardProject = store.getters.findProject({ _id: props.rowData.project._id });
      return cardProject.hasNesetedProjectInvLoc(store.state.userData);
    });

    return {
      create,
      submit,
      reserveMaterials,
      hasNestedInvLoc,
      shouldCreateBom,
      bomsToSubmit,
      hasMaterials
    };
  },
});
</script>
